import { combineReducers } from 'redux'
import { routerReducer } from 'react-router-redux'

import user from './user';
import jobs from './jobs';
import files from './files';
import data from './data';
import publish from './publish';
import news from './news';

export default combineReducers({
  routing: routerReducer,
  user,
  jobs,
  files,
  data,
  publish,
  news,
})



// WEBPACK FOOTER //
// ./src/reducers/index.js